//Set the gross price when the page is loaded for the first time
document.addEventListener('DOMContentLoaded', () => {
  const bruttoPriceElementStart = document.getElementById('brutto-price-info-start');
  if (bruttoPriceElementStart) {
    const bruttoPrice = parseFloat(bruttoPriceElementStart.getAttribute('data-brutto-price').replace(',', '.'));
    updateBruttoPriceElementStart(bruttoPrice);
  }
});

function updateBruttoPriceElementStart(bruttoPrice) {
  const bruttoPriceFormatted = bruttoPrice.toFixed(2).replace('.', ',') + ' €';
  const bruttoPriceValueElementMain = document.getElementById('brutto-price-value-main');
  if (bruttoPriceValueElementMain) {
    bruttoPriceValueElementMain.innerHTML = bruttoPriceFormatted;
  }
}

// Adding the gross price to the line item property addition-price-info & Update gross price in content
function updateBruttoPriceElement(netPrice) {
  const bruttoPrice = roundToTwo(netPrice * 1.19);
  const bruttoPriceFormatted = bruttoPrice.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' € inkl. 19 % MwSt.';

  const additionalPriceInfoElement = document.querySelector('.js-additional-price-info');
  const additionalPriceInput = document.querySelector('.js-additional-price-input');
  const bruttoPriceSpan = document.getElementById('brutto-price-value-main');
  
  
  if (additionalPriceInfoElement && additionalPriceInput && bruttoPriceSpan) {
    bruttoPriceSpan.innerHTML = bruttoPriceFormatted;
    additionalPriceInput.value = additionalPriceInfoElement.textContent.trim() + ` (Standard-Bruttopreis: ${bruttoPriceFormatted})`;
  }
}

function roundToTwo(num) {
  return +(Math.round(num + "e+2")  + "e-2");
}